import type { ReactNode } from 'react';
import type { ModalData } from '..';

export interface MtBookingUpdateModalData {
  modal: ModalData;
  slotPickerComponent: ReactNode;
}

export interface MtBookingUpdateModalProps extends MtBookingUpdateModalData {}
